import Vue from "vue";
import Vuex from "vuex";
import { ListStore } from "@flowlist/vue-listview";
import * as api from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false, // required
  modules: {
    list: ListStore({ api }),
  },
});
